export default __webpack_public_path__ + "static/media/blackAzure.bb18b754.svg";